import React, { FC, useState } from 'react'
import { TextInputFactory } from './TextInputFactory'
import { Props } from './Question'
import { validatePassword } from '@lib/validators'

export const PassReqFactory: FC<Props> = (props) => {
  const [hasError, setHasError] = useState<boolean>(false)

  const checkErrors = () => {
    const pass = props.value
    const error = !!validatePassword(props.inputData, pass, props.inputData, pass)

    setHasError(error)
  }

  return (
    <div>
      <TextInputFactory
        {...props}
        onBlur={checkErrors}
        inputData={{
          ...props.inputData,
          type: 'password'
        }}
        error={hasError}
      />
    </div>
  );
}
